<template>
  <div style="border: 1px solid grey; border-radius: 20px" class="pa-3">
    <div v-if="Object.keys(selectedProvince).length > 0">
      <h2>{{ selectedProvince.province_name_th }}</h2>
      <h3>Service list:</h3>
      <div
        v-for="(service, index) in selectedProvince.province_service_list"
        :key="index"
      >
        <v-layout row align-center>
          <v-flex>
            <span>{{ service.service_name_en }}</span>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs2>
            <!-- <v-switch
              @change="openCloseService($event,service)"
              color="primary"
              v-model="service.service_active"
            ></v-switch>-->
          </v-flex>
          <v-flex xs2>
            <v-btn
              icon
              :disabled="!service.service_active"
              @click="toEdit(service)"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <div v-else>
      <div>Please select a province</div>
    </div>
    <v-dialog persistent v-model="showInactiveDialog" hide-overlay>
      <v-form v-model="valid" ref="formInactive" lazy-validation>
        <v-card>
          <v-toolbar dark>
            <v-toolbar-title>Inactive form</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialogInactive()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text style="height: 70vh; overflow: scroll">
            <v-radio-group
              :rules="[(v) => !!v || 'Required']"
              v-model="formEdit.service_inactive_detail.service_inactive_type"
              row
            >
              <v-radio :value="1" label="INACTIVE"></v-radio>
              <v-radio :value="2" label="MAINTENANCE"></v-radio>
              <v-radio :value="3" label="COMING SOON"></v-radio>
            </v-radio-group>
            <div
              style="border: 1px solid #222222; border-radius: 15px"
              class="pa-3"
            >
              <v-layout row wrap class="align-center">
                <div>Image:</div>
                <v-btn
                  color="info"
                  class="white--text"
                  @click="$refs.ImageInput.click()"
                >
                  Upload Image
                  <v-icon right dark>cloud_upload</v-icon>
                </v-btn>
              </v-layout>
              <img :src="imgSrc" alt width="75px" height="75px" v-if="imgSrc" />
              <img
                :src="formEdit.service_inactive_detail.service_inactive_image"
                alt
                width="75px"
                height="75px"
                v-else
              />
            </div>
            <input
              style="display: none"
              type="file"
              @change="onImageSelected"
              ref="ImageInput"
              accept="image/*"
            />

            <v-layout row align-center>
              <span class="pr-2">Icon:</span>
              <img
                :src="iconSrc"
                alt
                width="30px"
                height="30px"
                v-if="iconSrc"
              />
              <img
                :src="formEdit.service_inactive_detail.service_inactive_icon"
                alt
                width="30px"
                height="30px"
                v-else-if="
                  formEdit.service_inactive_detail.service_inactive_icon
                "
              />

              <v-btn icon class="black--text" @click="$refs.IconInput.click()">
                <v-icon>edit</v-icon>
              </v-btn>
            </v-layout>
            <input
              style="display: none"
              type="file"
              @change="onIconSelected"
              ref="IconInput"
              accept="image/*"
            />

            <v-text-field
              :rules="[
                (v) => !!v || 'Required',
                (v) => v.length <= 50 || 'Character less than or equal to 50',
              ]"
              label="Title TH"
              v-model="
                formEdit.service_inactive_detail.service_inactive_title_th
              "
              counter="50"
            ></v-text-field>
            <v-text-field
              :rules="[
                (v) => !!v || 'Required',
                (v) => v.length <= 50 || 'Character less than or equal to 50',
              ]"
              label="Title EN"
              v-model="
                formEdit.service_inactive_detail.service_inactive_title_en
              "
              counter="50"
            ></v-text-field>
            <v-textarea
              :rules="[(v) => !!v || 'Required']"
              label="Description TH"
              v-model="
                formEdit.service_inactive_detail.service_inactive_description_th
              "
            ></v-textarea>
            <v-textarea
              :rules="[(v) => !!v || 'Required']"
              label="Description EN"
              v-model="
                formEdit.service_inactive_detail.service_inactive_description_en
              "
            ></v-textarea>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="inActiveService()">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog persistent v-model="showEditDialog" width="500">
      <v-card v-if="!isLoadingEdit">
        <v-toolbar dark>
          <v-toolbar-title style="display: flex; align-items: center">
            <div class="pr-3" style="display: flex; align-items: center">
              <img
                :src="formEdit.service_icon_image"
                width="35px"
                height="35px"
              />
            </div>
            {{ formEdit.service_name_en }} Service
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialogEdit()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="height: 80vh; overflow: auto">
          <div
            style="
              border: 2px solid #e7e7e7;
              border-radius: 20px;
              padding: 20px;
            "
          >
            <div style="display: flex">
              <span class="content-title pr-2">Name: </span>
              <span class="content-subtitle"
                >{{ formEdit.service_name_th }}
                <span class="content-subtitle--en">
                  ( {{ formEdit.service_name_en }} )</span
                ></span
              >
            </div>

            <v-divider class="mt-3"></v-divider>
            <div>
              <div class="content-title d-flex align-center">
                Image
                <input
                  style="display: none"
                  type="file"
                  @change="onBannerSelected"
                  ref="BannerInput"
                  accept="image/*"
                />
                <span>
                  <v-btn icon @click="$refs.BannerInput.click()">
                    <v-icon color="info">edit</v-icon>
                  </v-btn>
                </span>
              </div>
              <img
                :src="bannerImageSrc"
                alt=""
                width="100px"
                height="100px"
                v-if="bannerImageSrc != ''"
              />
              <img
                v-else-if="formEdit.service_image != null"
                :src="formEdit.service_image"
                width="100px"
                height="100px"
              />
              <div
                v-if="bannerImageSrc != ''"
                style="display: flex; justify-content: flex-end"
              >
                <v-btn
                  color="success"
                  flat
                  :loading="updating"
                  @click="updateBannerImage()"
                  >update</v-btn
                >
                <v-btn color="error" flat @click="bannerImageSrc = ''"
                  >clear</v-btn
                >
              </div>
            </div>
          </div>
          <div
            style="
              border: 2px solid #e7e7e7;
              border-radius: 20px;
              padding: 20px;
              margin-top: 24px;
            "
          >
            <v-layout row>
              <v-flex xs9>
                <v-layout row wrap>
                  <v-flex xs6>
                    <span class="content-title pr-2">Time start:</span>
                  </v-flex>
                  <v-flex xs6>
                    <vue-timepicker
                      color="primary"
                      class="custom-timepicker"
                      v-model="formEdit.time_start"
                      format="HH:mm"
                    ></vue-timepicker>
                  </v-flex>
                  <v-flex xs6>
                    <span class="content-title pr-2">Time end:</span>
                  </v-flex>
                  <v-flex xs6>
                    <vue-timepicker
                      color="primary"
                      class="custom-timepicker"
                      v-model="formEdit.time_end"
                      format="HH:mm"
                    ></vue-timepicker>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3 style="display: flex; align-items: center">
                <v-btn
                  color="primary"
                  @click="editTimeStartEnd()"
                  style="color: black"
                >
                  <v-icon small class="pr-1">save</v-icon>
                  <span>SAVE</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
          <div
            style="
              border: 2px solid #e7e7e7;
              border-radius: 20px;
              padding: 0px 10px 10px 10px;
              margin-top: 15px;
            "
          >
            <v-layout row wrap align-center>
              <v-switch
                @change="showHideService($event)"
                hide-details
                color="primary"
                v-model="formEdit.service_status"
                :label="
                  formEdit.service_status ? 'Visible: Show' : 'Visible: Hide'
                "
              ></v-switch>
              <v-switch
                hide-details
                @change="toInactive($event)"
                :true-value="0"
                :false-value="1"
                v-model="formEdit.service_inactive_detail.service_inactive_type"
                color="primary"
                :label="
                  formEdit.service_inactive_detail.service_inactive_type == 3
                    ? 'Status: Coming soon'
                    : formEdit.service_inactive_detail.service_inactive_type ==
                      2
                    ? 'Status: Maintenance'
                    : formEdit.service_inactive_detail.service_inactive_type ==
                      1
                    ? 'Status: Inactive'
                    : formEdit.service_inactive_detail.service_inactive_type ==
                      0
                    ? 'Status: Active'
                    : 'Status: Unknown'
                "
              ></v-switch>
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
      <v-card color="primary" dark v-else>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>

      <v-dialog v-model="is_crop_image" persistent max-width="60vw">
        <v-card>
          <v-card-title style="background-color: black; color: white">
            <h3>ตัดครอบรูปภาพ</h3>
          </v-card-title>
          <v-card-text>
            <imageCropper
              :aspectRatio="1 / 1"
              :imageName="cropImageName"
              :imgSrc="cropImageURL"
              :height="300"
              @close="is_crop_image = false"
              @setImageName="cropImageName = $event"
              @getCroped="getCropped($event)"
              v-if="cropImageURL != ''"
            ></imageCropper>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-dialog>
  </div>
</template>

<script>
import imageCropper from "@/components/Plugins/imageCropper.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import moment from "moment";
export default {
  props: ["selectedProvince"],
  data() {
    return {
      updating: false,
      is_crop_image: false,
      cropImageName: "",
      cropImageURL: "",
      valid: true,
      showEditDialog: false,
      showInactiveDialog: false,
      isLoadingEdit: false,
      isInactive: false,
      bannerImageSrc: "",
      imgSrc: "",
      iconSrc: "",
      formEdit: {
        service_type: 1,
        service_name_th: "อาหาร",
        service_name_en: "Food",
        service_description_th: null,
        service_description_en: null,
        service_icon_image:
          "https://storage.googleapis.com/internal-weserve/img/none/no_img.png",
        service_domain: "https://mgt-be.v4.weserve.co.th",
        service_time_start: "00:00:00.000000",
        service_time_end: "23:59:59.000000",
        service_status: true,
        service_image:
          "https://storage.googleapis.com/internal-weserve/img/none/no_img.png",
        service_inactive_detail: {
          service_inactive_type: 0,
          service_inactive_image:
            "https://storage.googleapis.com/internal-weserve/img/none/no_img.png",
          service_inactive_icon:
            "https://storage.googleapis.com/internal-weserve/img/none/no_img.png",
          service_inactive_title_th: "ซ่อมแปบ",
          service_inactive_title_en: "ซ่อมแปบ",
          service_inactive_description_th: "รอแปบ ๆ นะ",
          service_inactive_description_en: "รอแปบ ๆ นะ",
        },
      },
      isEditingService: false,
    };
  },
  components: {
    VueTimepicker,
    imageCropper,
  },
  computed: {},
  methods: {
    async updateBannerImage() {
      this.updating = true;
      let payload = {
        service_image: this.bannerImageSrc,
      };
      let config = {
        service_type: this.formEdit.service_type,
        province_id: this.selectedProvince.province_id,
      };
      let result = await this.$store.dispatch(
        "fetchProvinceBack/updateServiceBanner",
        { form: payload, config: config }
      );
      if (result == false) return;
      this.formEdit.service_image = result;
      this.bannerImageSrc = "";
      this.updating = false;
    },
    async openCloseService($event, service) {
      let configPath = {
        service_id: service.service_type,
        province_id: this.selectedProvince.province_id,
      };
      let result = await this.$store.dispatch(
        "fetchProvinceBack/openCloseService",
        configPath
      );
      if (result == false) {
        service.service_active = !service.service_active;
      }
    },
    async showHideService(value) {
      let configPath = {
        service_id: this.formEdit.service_type,
        province_id: this.selectedProvince.province_id,
      };
      let result = await this.$store.dispatch(
        "fetchProvinceBack/toggleShowHideService",
        configPath
      );
      if (result == false) {
        this.formEdit.service_status = !this.formEdit.service_status;
      }
    },

    async inActiveService() {
      if (this.$refs.formInactive.validate()) {
        this.isInactive = true;
        let form = JSON.parse(JSON.stringify(this.formEdit));
        let configPath = {
          province_id: this.selectedProvince.province_id,
          service_id: form.service_type,
        };
        if (this.imgSrc == "") {
          delete form.service_inactive_detail.service_inactive_image;
        } else {
          form.service_inactive_detail.service_inactive_image = this.imgSrc;
        }
        if (this.iconSrc == "") {
          delete form.service_inactive_detail.service_inactive_icon;
        } else {
          form.service_inactive_detail.service_inactive_icon = this.iconSrc;
        }
        let result = await this.$store.dispatch(
          "fetchProvinceBack/editServiceDetail",
          {
            configPath,
            form,
          }
        );
        if (result == false) {
          let index = this.selectedProvince.province_service_list.findIndex(
            (val) => val.service_type == form.service_type
          );
          this.selectedProvince.province_service_list[
            index
          ].service_inactive_detail.service_inactive_type = 0;
        } else {
          this.showInactiveDialog = false;
          this.imgSrc = "";
          this.iconSrc = "";
        }
        this.isInactive = false;
      }
    },
    closeDialogEdit() {
      this.resetFormEdit();
      this.showEditDialog = false;
    },
    async toEdit(service) {
      this.bannerImageSrc = "";
      this.showEditDialog = true;
      let configPath = {
        province_id: this.selectedProvince.province_id,
        service_id: service.service_type,
      };
      this.isLoadingEdit = true;
      let response = await this.$store.dispatch(
        "fetchProvinceBack/getServiceDetail",
        configPath
      );
      response.time_start = {
        HH: "",
        mm: "",
      };
      response.time_end = {
        HH: "",
        mm: "",
      };
      if (response.service_time_start && response.service_time_start != null) {
        response.time_start.HH = response.service_time_start.split(":")[0];
        response.time_start.mm = response.service_time_start.split(":")[1];
      }
      if (response.service_time_end && response.service_time_end != null) {
        response.time_end.HH = response.service_time_end.split(":")[0];
        response.time_end.mm = response.service_time_end.split(":")[1];
      }
      this.formEdit = response;
      this.isLoadingEdit = false;
    },
    closeDialogInactive() {
      this.showInactiveDialog = false;
      if (this.formEdit.service_inactive_detail.service_inactive_type == 0) {
        this.formEdit.service_inactive_detail.service_inactive_type = 1;
      } else if (
        this.formEdit.service_inactive_detail.service_inactive_type == 1
      ) {
        this.formEdit.service_inactive_detail.service_inactive_type = 0;
      }
    },
    async toInactive(value) {
      if (value == 1) {
        this.showInactiveDialog = true;
      } else if (value == 0) {
        let form = JSON.parse(JSON.stringify(this.formEdit));
        let configPath = {
          province_id: this.selectedProvince.province_id,
          service_id: this.formEdit.service_type,
        };

        delete form.service_inactive_detail.service_inactive_image;
        delete form.service_inactive_detail.service_inactive_icon;
        let result = await this.$store.dispatch(
          "fetchProvinceBack/editServiceDetail",
          {
            configPath,
            form,
          }
        );
        if (result == false) {
          this.formEdit.service_inactive_detail.service_inactive_type = 1;
        }
      }
    },
    onImageSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imgSrc = reader.result;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    getCropped(image_value) {
      this.bannerImageSrc = image_value;
      this.cropImageURL = "";
      this.cropImageName = "";
    },
    onBannerSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      this.cropImageName = file.name;
      reader.addEventListener("load", () => {
        this.cropImageURL = reader.result;
        this.is_crop_image = true;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    onIconSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.iconSrc = reader.result;
        // this.formEdit.service_inactive_detail.service_inactive_icon =
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    resetFormEdit() {
      this.formEdit = {
        service_type: 1,
        service_name_th: "",
        service_name_en: "",
        service_description_th: null,
        service_description_en: null,
        service_icon_image:
          "https://storage.googleapis.com/pre-weserve/img/none/no_img.png",
        service_domain: "https://pre-backend.v4.weserve.co.th",
        service_time_start: "",
        service_time_end: "",
        service_image:
          "https://storage.googleapis.com/pre-weserve/img/none/no_img.png",
        service_status: true,
        service_inactive_detail: {
          service_inactive_type: 0,
          service_inactive_image:
            "https://storage.googleapis.com/pre-weserve/img/none/no_img.png",
          service_inactive_icon:
            "https://storage.googleapis.com/pre-weserve/img/none/no_img.png",
          service_inactive_title_th: "",
          service_inactive_title_en: "",
          service_inactive_description_th: "",
          service_inactive_description_en: "",
        },
        time_start: { HH: "", mm: "" },
        time_end: { HH: "", mm: "" },
      };
    },
    async editTimeStartEnd() {
      if (
        this.formEdit.time_start.HH &&
        this.formEdit.time_start.mm &&
        this.formEdit.time_end.HH &&
        this.formEdit.time_end.mm
      ) {
        let currentDate = new Date();
        let startDate = new Date(currentDate.getTime());
        startDate.setHours(this.formEdit.time_start.HH);
        startDate.setMinutes(this.formEdit.time_start.mm);
        startDate.setSeconds("00");

        let endDate = new Date(currentDate.getTime());
        endDate.setHours(this.formEdit.time_end.HH);
        endDate.setMinutes(this.formEdit.time_end.mm);
        endDate.setSeconds("00");
        if (startDate > endDate)
          return alert("โปรดเลือกเวลาเปิด - ปิดให้ถูกต้อง");
        this.showEditDialog = false;
        let form = JSON.parse(JSON.stringify(this.formEdit));
        form.service_time_start =
          form.time_start.HH + ":" + form.time_start.mm + ":00";
        form.service_time_end =
          form.time_end.HH + ":" + form.time_end.mm + ":00";
        delete form.time_start;
        delete form.time_end;
        let configPath = {
          province_id: this.selectedProvince.province_id,
          service_id: form.service_type,
        };
        this.isEditingService = true;
        delete form.service_inactive_detail.service_inactive_icon;
        delete form.service_inactive_detail.service_inactive_image;
        await this.$store.dispatch("fetchProvinceBack/editServiceDetail", {
          configPath,
          form,
        });
        this.isEditingService = false;
      } else {
        alert("โปรดเลือกเวลาเปิด - ปิด");
      }
    },
  },
};
</script>

<style>
.custom-timepicker.time-picker .display-time {
  outline: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  border-top: none;
  border-left: none;
  border-right: none;
  width: 9.3em;
  color: rgba(0, 0, 0, 0.54);
}

.custom-timepicker .dropdown ul li.active,
.custom-timepicker .dropdown ul li.active:hover {
  background: #ffd600;
  color: black;
}

.custom-timepicker.time-picker .display-time:hover {
  border-bottom: 1px solid #222222;
}

.custom-timepicker.time-picker .display-time:focus {
  border-bottom: 1px solid #222222;
}
</style>
<style scoped>
.content-title {
  font-size: 18px;
  font-weight: bold;
}
.content-subtitle {
  font-size: 18px;
}

.content-subtitle--en {
  font-size: 16px;
  color: grey;
}
</style>
